/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { organizationRemoteSessionIssuersCreate } from "../funcs/organizationRemoteSessionIssuersCreate.js";
import { organizationRemoteSessionIssuersDelete } from "../funcs/organizationRemoteSessionIssuersDelete.js";
import { organizationRemoteSessionIssuersFetchMetadata } from "../funcs/organizationRemoteSessionIssuersFetchMetadata.js";
import { organizationRemoteSessionIssuersGet } from "../funcs/organizationRemoteSessionIssuersGet.js";
import { organizationRemoteSessionIssuersGetDeletePreflight } from "../funcs/organizationRemoteSessionIssuersGetDeletePreflight.js";
import { organizationRemoteSessionIssuersGetDuplicatePreflight } from "../funcs/organizationRemoteSessionIssuersGetDuplicatePreflight.js";
import { organizationRemoteSessionIssuersGetMigratePreflight } from "../funcs/organizationRemoteSessionIssuersGetMigratePreflight.js";
import { organizationRemoteSessionIssuersList } from "../funcs/organizationRemoteSessionIssuersList.js";
import { organizationRemoteSessionIssuersMigrate } from "../funcs/organizationRemoteSessionIssuersMigrate.js";
import { organizationRemoteSessionIssuersMove } from "../funcs/organizationRemoteSessionIssuersMove.js";
import { organizationRemoteSessionIssuersRefreshMetadata } from "../funcs/organizationRemoteSessionIssuersRefreshMetadata.js";
import { organizationRemoteSessionIssuersSetEMAProviders } from "../funcs/organizationRemoteSessionIssuersSetEMAProviders.js";
import { organizationRemoteSessionIssuersUpdate } from "../funcs/organizationRemoteSessionIssuersUpdate.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { EMAProviderOrder } from "../models/components/emaproviderorder.js";
import { MigrateOrganizationRemoteSessionIssuerResult } from "../models/components/migrateorganizationremotesessionissuerresult.js";
import { OrganizationIssuerDeletePreflight } from "../models/components/organizationissuerdeletepreflight.js";
import { OrganizationIssuerMigratePreflight } from "../models/components/organizationissuermigratepreflight.js";
import { RemoteSessionIssuer } from "../models/components/remotesessionissuer.js";
import { RemoteSessionIssuerDraft } from "../models/components/remotesessionissuerdraft.js";
import { RemoteSessionIssuerDuplicatePreflight } from "../models/components/remotesessionissuerduplicatepreflight.js";
import { RemoteSessionIssuerRefresh } from "../models/components/remotesessionissuerrefresh.js";
import {
  CreateOrganizationRemoteSessionIssuerRequest,
  CreateOrganizationRemoteSessionIssuerSecurity,
} from "../models/operations/createorganizationremotesessionissuer.js";
import {
  DeleteOrganizationRemoteSessionIssuerRequest,
  DeleteOrganizationRemoteSessionIssuerSecurity,
} from "../models/operations/deleteorganizationremotesessionissuer.js";
import {
  FetchOrganizationRemoteSessionIssuerMetadataRequest,
  FetchOrganizationRemoteSessionIssuerMetadataSecurity,
} from "../models/operations/fetchorganizationremotesessionissuermetadata.js";
import {
  GetOrganizationRemoteSessionIssuerRequest,
  GetOrganizationRemoteSessionIssuerSecurity,
} from "../models/operations/getorganizationremotesessionissuer.js";
import {
  GetOrganizationRemoteSessionIssuerDeletePreflightRequest,
  GetOrganizationRemoteSessionIssuerDeletePreflightSecurity,
} from "../models/operations/getorganizationremotesessionissuerdeletepreflight.js";
import {
  GetOrganizationRemoteSessionIssuerDuplicatePreflightRequest,
  GetOrganizationRemoteSessionIssuerDuplicatePreflightSecurity,
} from "../models/operations/getorganizationremotesessionissuerduplicatepreflight.js";
import {
  GetOrganizationRemoteSessionIssuerMigratePreflightRequest,
  GetOrganizationRemoteSessionIssuerMigratePreflightSecurity,
} from "../models/operations/getorganizationremotesessionissuermigratepreflight.js";
import {
  ListOrganizationRemoteSessionIssuersRequest,
  ListOrganizationRemoteSessionIssuersResponse,
  ListOrganizationRemoteSessionIssuersSecurity,
} from "../models/operations/listorganizationremotesessionissuers.js";
import {
  MigrateOrganizationRemoteSessionIssuerRequest,
  MigrateOrganizationRemoteSessionIssuerSecurity,
} from "../models/operations/migrateorganizationremotesessionissuer.js";
import {
  MoveOrganizationRemoteSessionIssuerRequest,
  MoveOrganizationRemoteSessionIssuerSecurity,
} from "../models/operations/moveorganizationremotesessionissuer.js";
import {
  RefreshOrganizationRemoteSessionIssuerMetadataRequest,
  RefreshOrganizationRemoteSessionIssuerMetadataSecurity,
} from "../models/operations/refreshorganizationremotesessionissuermetadata.js";
import {
  SetOrganizationRemoteSessionIssuerEMAProvidersRequest,
  SetOrganizationRemoteSessionIssuerEMAProvidersSecurity,
} from "../models/operations/setorganizationremotesessionissueremaproviders.js";
import {
  UpdateOrganizationRemoteSessionIssuerRequest,
  UpdateOrganizationRemoteSessionIssuerSecurity,
} from "../models/operations/updateorganizationremotesessionissuer.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";

export class OrganizationRemoteSessionIssuers extends ClientSDK {
  /**
   * createIssuer organizationRemoteSessionIssuers
   *
   * @remarks
   * Create a remote_session_issuer in the caller's organization. With no project_id the issuer is organization-level (project_id NULL, inherited by every project); with a project_id (which must belong to the organization) it is project-specific. Requires org:admin.
   */
  async create(
    request: CreateOrganizationRemoteSessionIssuerRequest,
    security?: CreateOrganizationRemoteSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionIssuer> {
    return unwrapAsync(organizationRemoteSessionIssuersCreate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteIssuer organizationRemoteSessionIssuers
   *
   * @remarks
   * Soft-delete any remote_session_issuer (organizational or project-specific) in the caller's organization. Blocked when any remote_session_clients still reference it. Requires org:admin.
   */
  async delete(
    request: DeleteOrganizationRemoteSessionIssuerRequest,
    security?: DeleteOrganizationRemoteSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(organizationRemoteSessionIssuersDelete(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * fetchIssuerMetadata organizationRemoteSessionIssuers
   *
   * @remarks
   * Hit an upstream issuer's RFC 8414 .well-known/oauth-authorization-server document and return a draft suitable for organizationRemoteSessionIssuers.create. Keyed by issuer URL; no record need exist and nothing is persisted. The organization-scoped counterpart of remoteSessionIssuers.fetchMetadata, so creating an organization-level issuer no longer has to borrow an unrelated project's scope. Requires org:admin.
   */
  async fetchMetadata(
    request: FetchOrganizationRemoteSessionIssuerMetadataRequest,
    security?: FetchOrganizationRemoteSessionIssuerMetadataSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionIssuerDraft> {
    return unwrapAsync(organizationRemoteSessionIssuersFetchMetadata(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getIssuer organizationRemoteSessionIssuers
   *
   * @remarks
   * Get any remote_session_issuer (organizational or project-specific) in the caller's organization by id. Requires org:read.
   */
  async get(
    request: GetOrganizationRemoteSessionIssuerRequest,
    security?: GetOrganizationRemoteSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionIssuer> {
    return unwrapAsync(organizationRemoteSessionIssuersGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getIssuerDeletePreflight organizationRemoteSessionIssuers
   *
   * @remarks
   * Authoritative impact summary for deleting a remote_session_issuer: associated client count and affected MCP server names. Requires org:read.
   */
  async getDeletePreflight(
    request: GetOrganizationRemoteSessionIssuerDeletePreflightRequest,
    security?:
      | GetOrganizationRemoteSessionIssuerDeletePreflightSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<OrganizationIssuerDeletePreflight> {
    return unwrapAsync(organizationRemoteSessionIssuersGetDeletePreflight(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getIssuerDuplicatePreflight organizationRemoteSessionIssuers
   *
   * @remarks
   * Report the existing remote_session_issuers that already describe an upstream issuer URL, so a create or edit form can warn before it duplicates one. Requires org:read.
   *
   * Covers every issuer in the caller's organization — organization-level and project-specific alike — plus the platform catalog. The project-specific rows are the point: an organization administrator about to add an organization-level issuer most needs to know that several of their projects already configured the same URL separately, because those are exactly the records migrateIssuer can consolidate. The answer does not depend on whether the issuer being created is organization-level or project-scoped; an org administrator holds org:read either way.
   *
   * Advisory only. Duplicating an issuer URL is legitimate, so nothing here blocks a write and no lock is taken. Matching uses the same canonicalization as getRemoteSessionIssuer, and a URL that cannot be parsed as an issuer identifier returns no matches rather than an error.
   */
  async getDuplicatePreflight(
    request?:
      | GetOrganizationRemoteSessionIssuerDuplicatePreflightRequest
      | undefined,
    security?:
      | GetOrganizationRemoteSessionIssuerDuplicatePreflightSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionIssuerDuplicatePreflight> {
    return unwrapAsync(organizationRemoteSessionIssuersGetDuplicatePreflight(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getIssuerMigratePreflight organizationRemoteSessionIssuers
   *
   * @remarks
   * Authoritative impact summary for migrating a remote_session_issuer's clients onto another issuer: the clients that would move, the affected MCP servers, and every blocker (endpoint mismatches, conflicting MCP-server bindings). Requires org:read.
   */
  async getMigratePreflight(
    request: GetOrganizationRemoteSessionIssuerMigratePreflightRequest,
    security?:
      | GetOrganizationRemoteSessionIssuerMigratePreflightSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<OrganizationIssuerMigratePreflight> {
    return unwrapAsync(organizationRemoteSessionIssuersGetMigratePreflight(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listIssuers organizationRemoteSessionIssuers
   *
   * @remarks
   * List all remote_session_issuers in the caller's organization — organizational (project_id NULL) and project-specific — each with its associated client count and, for project-specific issuers, the owning project name. Requires org:read.
   */
  async list(
    request?: ListOrganizationRemoteSessionIssuersRequest | undefined,
    security?: ListOrganizationRemoteSessionIssuersSecurity | undefined,
    options?: RequestOptions,
  ): Promise<
    PageIterator<
      ListOrganizationRemoteSessionIssuersResponse,
      { cursor: string }
    >
  > {
    return unwrapResultIterator(organizationRemoteSessionIssuersList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * migrateIssuer organizationRemoteSessionIssuers
   *
   * @remarks
   * Consolidate two remote_session_issuers that point at the same upstream authorization server: re-point every client from the source issuer onto the target issuer, then soft-delete the source. Existing remote sessions are preserved, so no user re-authenticates. Both issuers must belong to the caller's organization and agree on issuer, token_endpoint, and authorization_endpoint. The issuer identifier is compared canonically, so two spellings differing only by a trailing slash or an explicit default port count as the same upstream; the two endpoints are compared literally. The target may not be narrower in scope than the source: a project-specific issuer may migrate onto an issuer in the same project or onto an organization-level issuer, and an organization-level issuer may migrate onto another organization-level issuer. Requires org:admin.
   */
  async migrate(
    request: MigrateOrganizationRemoteSessionIssuerRequest,
    security?: MigrateOrganizationRemoteSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<MigrateOrganizationRemoteSessionIssuerResult> {
    return unwrapAsync(organizationRemoteSessionIssuersMigrate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * moveIssuer organizationRemoteSessionIssuers
   *
   * @remarks
   * Re-scope a remote_session_issuer in the caller's organization: provide a project_id (which must belong to the organization) to make it project-specific, or omit it to make it organization-level (project_id NULL, inherited by every project). Requires org:admin.
   */
  async move(
    request: MoveOrganizationRemoteSessionIssuerRequest,
    security?: MoveOrganizationRemoteSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionIssuer> {
    return unwrapAsync(organizationRemoteSessionIssuersMove(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * refreshIssuerMetadata organizationRemoteSessionIssuers
   *
   * @remarks
   * Re-fetch an existing remote_session_issuer's RFC 8414 metadata document and persist the discovered values. Keyed by issuer id; serves both organizational and project-specific issuers in the caller's organization. Only RFC 8414-derived columns are written — endpoints, the *_supported arrays, client_id_metadata_document_supported, and the documentation URLs. Speakeasy behavior and display fields (oidc, passthrough, name, slug, logo, client setup documentation) are left alone. Requires org:admin.
   */
  async refreshMetadata(
    request: RefreshOrganizationRemoteSessionIssuerMetadataRequest,
    security?:
      | RefreshOrganizationRemoteSessionIssuerMetadataSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionIssuerRefresh> {
    return unwrapAsync(organizationRemoteSessionIssuersRefreshMetadata(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * setEMAProviders organizationRemoteSessionIssuers
   *
   * @remarks
   * Replace the ordered list of EMA providers that issue ID-JAGs for the vendor authorization server this issuer names. Identity chaining tries the providers that can serve and that the endpoint's authorization server trusts, in order, retrying transient failures briefly before moving to the next, until one succeeds. An empty list restores the default: the endpoint's configured external issuer. Speakeasy is used only for vendors whose list names it. The order applies organization-wide to every issuer with the same canonical issuer URL. Requires org:admin and the ema-providers rollout; restoring the default only needs org:admin. Not available from support or impersonated sessions.
   */
  async setEMAProviders(
    request: SetOrganizationRemoteSessionIssuerEMAProvidersRequest,
    security?:
      | SetOrganizationRemoteSessionIssuerEMAProvidersSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<EMAProviderOrder> {
    return unwrapAsync(organizationRemoteSessionIssuersSetEMAProviders(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateIssuer organizationRemoteSessionIssuers
   *
   * @remarks
   * Update any remote_session_issuer (organizational or project-specific) in the caller's organization. Requires org:admin.
   */
  async update(
    request: UpdateOrganizationRemoteSessionIssuerRequest,
    security?: UpdateOrganizationRemoteSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionIssuer> {
    return unwrapAsync(organizationRemoteSessionIssuersUpdate(
      this,
      request,
      security,
      options,
    ));
  }
}
